import { render, staticRenderFns } from "./ui-pull.vue?vue&type=template&id=3832f8c7"
import script from "./ui-pull.vue?vue&type=script&lang=js"
export * from "./ui-pull.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports